var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSectionTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3813 0C12.4584 0.0681648 11.6489 0.630177 11.2775 1.46207L2.46248 22.4666C1.85856 23.7742 1.02497 24.9678 0 25.993H3.73129L7.63285 26C8.55575 25.9304 9.36381 25.3684 9.73666 24.5365L18.5404 3.52788C19.1443 2.22022 19.9764 1.02525 21 0H13.3813Z",
    fill: "#E21F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionTitle);
export default __webpack_public_path__ + "static/media/icon_section_title.92fc4960ec2dfd7555d5348984e665a8.svg";
export { ForwardRef as ReactComponent };